module.exports = __webpack_public_path__ + "img/karl_moser.261bcdc3.png";